import { render, staticRenderFns } from "./StockTransit.vue?vue&type=template&id=3ae5ced6&"
import script from "./StockTransit.vue?vue&type=script&lang=js&"
export * from "./StockTransit.vue?vue&type=script&lang=js&"
import style0 from "./StockTransit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports